export default {
  fundPaymentApply: {
    column: {
      tenantCode: '租户编码',
      companyCode: '公司编码',
      departmentCode: '部门编码',
      companyName: '公司名',
      departmentName: '部门名',
      gmtCreate: '创建时间',
      gmtModified: '更新时间',
      lastModifiedBy: '最后更新人',
      isDeleted: '是否删除(1删除,0未删除)',
      sortNo: '序号',
      version: '版本',
      paymentApplyNumber: '付款申请单号',
      requestCompanyCode: '公司',
      requestCompanyName: '申请单公司名称',
      requestDepartmentCode: '部门',
      requestDepartmentName: '申请单部门名称',
      paymentType: '付款类别',
      payeeNo: '收款单位',
      payeeName: '收款单位名称',
      bankNo: '开户银行',
      bankName: '开户银行名称',
      bankAccount: '银行账号',
      bankUnionNumber: '联行号',
      bankBranch: '开户分行',
      paymentMethod: '付款方式',
      requestPersonNo: '申请人编码',
      requestPersonName: '申请人名称',
      requestAmount: '申请金额原币',
      requestAccountedAmount: '申请金额本位币',
      currencyCode: '币种编码',
      currencyName: '币种名称',
      exchangeType: '汇率类型',
      exchangeRate: '汇率',
      exchangeRateDate: '汇率日期',
      requestStatus: '单据状态',
      paidAmount: '已付款金额原币',
      unpaidAmount: '未付款金额原币',
      requestDate: '申请日期',
      isVirtual: '虚拟标识',
      paidAccountedAmount: '已付款金额本位币',
      unpaidAccountedAmount: '未付款金额本位币',
      availableCreditAmount: '可用信用额度',
      summary: '摘要',
      closeReason: '关闭原因',
      isAdvanceTax: '1代垫,0非代垫',
      isLogisticsApprove: '1提交,0不提交',
      isReceipt: '1收汇,0非收汇',
      isFundReexport: '1转口,0非转口',
      isFreeze: '1冻结,0非冻结',
      fundAllocationType: '资金调拨类型(字典)',
    },
    placeholder: {
      tenantCode: '请输入租户编码',
      companyCode: '请输入公司编码',
      departmentCode: '请输入部门编码',
      companyName: '请输入公司名',
      departmentName: '请输入部门名',
      gmtCreate: '请选择创建时间',
      gmtModified: '请选择更新时间',
      lastModifiedBy: '请输入最后更新人',
      isDeleted: '请输入是否删除(1删除,0未删除)',
      sortNo: '请输入序号',
      version: '请输入版本',
      paymentApplyNumber: '筛选多条时以逗号分隔',
      requestCompanyCode: '请输入申请单公司代码',
      requestCompanyName: '请输入申请单公司名称',
      requestDepartmentCode: '请输入申请单部门代码',
      requestDepartmentName: '请输入申请单部门名称',
      paymentType: '请选择付款类别(字典)',
      payeeNo: '请输入收款单位',
      payeeName: '请输入收款单位名称',
      bankNo: '请输入开户银行',
      bankName: '请输入开户银行名称',
      bankAccount: '请输入银行账号',
      bankUnionNumber: '请输入联行号',
      bankBranch: '请输入开户分行',
      paymentMethod: '请输入付款方式',
      requestPersonNo: '请输入申请人编码',
      requestPersonName: '请输入申请人名称',
      requestAmount: '请输入申请金额原币',
      requestAccountedAmount: '请输入申请金额本位币',
      currencyCode: '请输入币种编码',
      currencyName: '请输入币种名称',
      exchangeType: '请选择汇率类型',
      exchangeRate: '请输入汇率',
      exchangeRateDate: '请选择汇率日期',
      requestStatus: '请选择单据状态',
      paidAmount: '请输入已付款金额原币',
      unpaidAmount: '请输入未付款金额原币',
      requestDate: '请选择申请日期',
      isVirtual: '请输入1.虚拟,0非虚拟',
      paidAccountedAmount: '请输入已付款金额本位币',
      unpaidAccountedAmount: '请输入未付款金额本位币',
      availableCreditAmount: '请输入可用信用额度',
      summary: '请输入摘要',
      closeReason: '请输入关闭原因',
      isAdvanceTax: '请输入1代垫,0非代垫',
      isLogisticsApprove: '请输入1提交,0不提交',
      isReceipt: '请输入1收汇,0非收汇',
      isFundReexport: '请输入1转口,0非转口',
      isFreeze: '请输入1冻结,0非冻结',
      fundAllocationType: '请选择资金调拨类型(字典)',
    },
  },
  paymentList: {
    search: {
      startPaymentDate: '付款日期从',
      endPaymentDate: '付款日期到',
      startPaymentCreateDate: '创建日期从',
      endPaymentCreateDate: '创建日期到',
      supplychain: '供应链主体',
      supplychainPlaceholder: '请选择供应链主体',
    },
    table: {
      paymentCompanyCode: '公司',
      paymentApplyDepartmentNo: '部门',
      paymentApplyNumber: '付款申请单号',
      paymentNum: '付款单号',
      lineNumber: '付款单行编号',
      paymentType: '付款类别',
      paymentMethod: '付款方式',
      paymentDate: '付款日期',
      receiveCompanyNo: '收款单位',
      bankAccountName: '付款银行账户名称',
      bankAccountNum: '付款银行账号',
      paymentAmount: '付款金额',
      currencyCode: '币种',
      paymentAccountedAmount: '付款金额本位币',
      requestPersonName: '付款科目',
      cashAccName: '应付科目',
      cashFlowItemCode: '现金流代码',
      paymentStatus: '单据状态',
      accountingStatus: '入账状态',
      salesOrderNo: '销售合同号',
      purchaseOrderNo: '采购合同号',
      paymentCreatePersonName: '创建人',
      bankName: '银行名称',
    },
    message: {
      noDepartment: '缺少对应部门，请维护',
      onlyOneSelectData: '请选择一条数据进行操作',
      noEdit: '该状态无法编辑，只有已保存、支付失败状态可编辑',
      noSelected: '您还未选择任何数据!',
      noCanDelData: '所选数据中没有已保存和支付失败状态，请重新选择！',
      hasCannotDelTip: '所选数据中有不可删除的数据，点击确认只会删除已保存和支付失败状态的数据！',
    },
  },
};
